import { flexRender, isFunction, RowData } from '@tanstack/react-table';
import { Typography } from '@navi/web-ui/lib/primitives';
import naviTableStyles from '../../NaviTable.module.scss';
import styles from './NaviTableBody.module.scss';
import cx from 'classnames';
import { useNaviTableContext } from '../../context/NaviTableContext';
import { INaviTableCell, NaviTableColumnDef, NaviTableVariants } from '../../interfaces';
import { getColumnStyle, getTooltipInfo } from '../../utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@cp/src/components/TooltipV2/TooltipV2';
import NaviTableBodyCellValue from './NaviTableBodyCellValue';

const NaviTableBodyCell = <TData extends RowData>({ cell }: INaviTableCell<TData>) => {
  const {
    totalWidth,
    sizeColumnsToFit = true,
    variant = NaviTableVariants.DEFAULT,
    onCellClick
  } = useNaviTableContext<TData>();
  const columnDef = cell.column.columnDef as NaviTableColumnDef<TData>;
  const cellValue = flexRender(columnDef.cell, cell.getContext());

  const isCellValueString =
    isFunction(columnDef.cell) && typeof columnDef.cell(cell.getContext()) === 'string';

  const tooltipInfo = getTooltipInfo(cell);

  const handleCellClick = () => {
    if (isFunction(onCellClick)) {
      onCellClick(columnDef);
    }
  };

  const isCardVariant = variant === NaviTableVariants.CARDS;

  return (
    <div
      style={getColumnStyle(cell.column, totalWidth, columnDef?.cellStyle, sizeColumnsToFit)}
      className={styles.naviTableBodyCell}
      onClick={handleCellClick}
    >
      {tooltipInfo ? (
        <Tooltip
          placement={tooltipInfo?.position || 'top'}
          hiddenPadding={tooltipInfo?.hiddenPadding || { top: isCardVariant ? 100 : 20 }}
          hideStrategy="referenceHidden"
        >
          <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper max-w-full">
            <NaviTableBodyCellValue
              isCellValueString={isCellValueString}
              cellValue={cellValue}
              className="max-w-full"
            />
          </TooltipTrigger>
          <TooltipContent className={cx('tooltipWrapper', naviTableStyles.tooltip)}>
            {tooltipInfo.content}
          </TooltipContent>
        </Tooltip>
      ) : (
        <NaviTableBodyCellValue
          isCellValueString={isCellValueString}
          cellValue={cellValue}
          className="truncate w-full"
        />
      )}
    </div>
  );
};

export default NaviTableBodyCell;
